import raw from "raw.macro";
import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import slugify from "slugify";

import ContentArea from "../component/ContentArea";
import CustomHelmet from "../component/CustomHelmet";
import Intro from "../component/Intro";
import BaseContainer from "../component/layout/base-container";
import { illustrations } from "../lib/homeIllustrations";
import { components } from "../lib/markdownComponentMapping";
import { randomSelect } from "../lib/randomSelect";

export default function Home() {
  const startseite_text = raw("../textblocke/startseite.md");
  const startseite_about_text = raw("../textblocke/startseite_about.md");

  let illustrationsKeys = Object.keys(illustrations);

  return (
    <>
      <CustomHelmet />
      <BaseContainer>
        <Intro title="Willkommen bei FormATool">
          <ReactMarkdown components={components} className="Intro--text">
            {startseite_text}
          </ReactMarkdown>
        </Intro>
        <ContentArea>
          <div className="flex flex-col justify-between sm:flex-row">
            {illustrationsKeys.map((key) => (
              <div key={key}>
                <Link
                  to={key === "Lehrperson" ? "dashboard" : "umfrage"}
                  id={slugify(`link ${key}`, { remove: "*" })}
                  className="Link size-small"
                >
                  <div>
                    <img
                      src={randomSelect(illustrations[key])}
                      alt={key}
                      style={{ width: "100%", maxHeight: 200 }}
                    />
                  </div>
                  <div className="Teaser--linkList--link mt-8 flex justify-center">
                    {key}
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <div className="mt-[64px]    max-w-3xl">
            <h2 className="TextImage--title">Über FormATool</h2>
            <ReactMarkdown components={components} className="Intro--text">
              {startseite_about_text}
            </ReactMarkdown>
          </div>
        </ContentArea>
      </BaseContainer>
    </>
  );
}
